import React, { createContext, useContext, useEffect, useRef } from 'react';
import { useEntityConfigurator } from './hooks/useEntityConfigurator';
import { useGetEntities } from './hooks/useGetEntities';
import { defaultEntityPlugins } from './plugins';
import { defaultRulePlugins } from './rules/default';
export const EntityContext = createContext(null);
export const useEntityContext = (params) => {
    const context = useContext(EntityContext);
    if (!context && !(params === null || params === void 0 ? void 0 : params.ignoreUndefined)) {
        throw new Error('useEntityContext must be used within the context of the EntityProvider component');
    }
    return context;
};
export const EntityProvider = props => {
    const { children, plugins, rules, onEntities, allowVersioning, allowWorkflow, 
    // default to `true` if not provided (undefined) to properly load entities
    hasUser = true } = props;
    const existingEntityContext = useEntityContext({ ignoreUndefined: true });
    const pluginsRef = useRef(plugins || defaultEntityPlugins);
    const rulesRef = useRef(rules || defaultRulePlugins);
    const onEntitiesRef = useRef(onEntities);
    const getEntitiesApi = useGetEntities();
    const useEntityConfiguratorApi = useEntityConfigurator(pluginsRef.current);
    // load entities on init
    const { entities, getEntities } = getEntitiesApi;
    useEffect(() => {
        // SiteContext loads EntityContext and EntityEditor also loads an instance
        // of the EntityContext. So, add logic to only have one instance of the
        // EntityContext.
        // only fetch when user exists
        if (!existingEntityContext && hasUser) {
            getEntities(true);
        }
    }, [getEntities, existingEntityContext, hasUser]);
    useEffect(() => {
        var _a;
        if (entities) {
            (_a = onEntitiesRef.current) === null || _a === void 0 ? void 0 : _a.call(onEntitiesRef, entities);
        }
    }, [entities]);
    // Make sure only one instance of the EntityContext exists
    return existingEntityContext ? (React.createElement(React.Fragment, null, children)) : (React.createElement(EntityContext.Provider, { value: Object.assign(Object.assign({ allowVersioning,
            allowWorkflow, plugins: pluginsRef.current, rules: rulesRef.current }, getEntitiesApi), useEntityConfiguratorApi) }, children));
};
//# sourceMappingURL=EntityContext.js.map